import React, { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { useNavigate } from 'react-router-dom';

export default function UniversesList() {
  const [universes, setUniverses] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUniverses = async () => {
      const { data, error } = await supabase.from('universes').select('*');
      if (!error && data) {
        const valid = data.filter((u) => typeof u.code === 'string' && u.code.trim() !== '');
        const sorted = valid.sort((a, b) => a.code.localeCompare(b.code));
        setUniverses(sorted);
      }
    };

    fetchUniverses();
  }, []);

  const handleClick = (code) => {
    navigate(`/universo/${code}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white font-sans">
      {/* Botón de regreso */}
      <div className="flex justify-start max-w-7xl mx-auto px-4 pt-6">
        <button
          onClick={() => navigate('/')}
          className="bg-white text-purple-600 font-bold py-2 px-4 rounded-lg shadow-md hover:bg-purple-100 transition"
        >
          🏠 Back to Nubbi
        </button>
      </div>

      {/* Título principal */}
      <header className="text-center py-10">
        <h1 className="text-4xl md:text-5xl font-extrabold drop-shadow-lg">🌌 Select a Nubbiverse</h1>
      </header>

      {/* Galería de universos */}
      <div className="flex flex-wrap justify-center gap-6 px-4 pb-16">
        {universes.map((universe) => (
          <div
            key={universe.code}
            onClick={() => handleClick(universe.code)}
            className="cursor-pointer bg-white bg-opacity-20 rounded-2xl p-4 w-40 h-52 flex flex-col items-center justify-center shadow-xl transform hover:scale-110 transition"
          >
            <img
              src={universe.image_url || '/fallback.png'}
              alt={universe.name}
              className="w-24 h-24 object-contain rounded-xl mb-4 shadow-lg bg-white"
            />
            <p className="text-lg font-extrabold text-white drop-shadow-sm text-center">{universe.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
